<template>
    <div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
        <el-breadcrumb>
            <el-breadcrumb-item>商家管理</el-breadcrumb-item>
        </el-breadcrumb>

        <el-form :inline="true" :model="item" class="search">
            <el-form-item label="商家名称">
                <el-input v-model="item.businessName" placeholder="请输入商家名称"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="手机号码">
                <el-input v-model="item.mobile" placeholder="请输入手机号码"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item label="营业执照号">
                <el-input v-model="item.licenseNumber" placeholder="请输入营业执照号"
                          size="small"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" size="medium">查询</el-button>
                <el-button type="success" @click="excelOut" size="medium">导出商家
                </el-button>
            </el-form-item>
        </el-form>

        <div class="btns">
            <el-button type="primary" size="small" @click="add">添加商家</el-button>
            <el-button type="danger" size="small" @click="delAll">批量删除</el-button>
        </div>


        <el-table :data="list" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" align="center"></el-table-column>
			<el-table-column width="60" align="center">
				<template slot-scope="scope">
					{{scope.$index + (page-1) * pageSize + 1}}
				</template>
			</el-table-column>
            <el-table-column prop="id" label="商家ID"></el-table-column>
            <el-table-column prop="businessName" label="商家名称"></el-table-column>
            <el-table-column prop="bankAccount" label="银行账号"></el-table-column>
            <el-table-column prop="bankName" label="银行开户名"></el-table-column>
            <el-table-column prop="legalPerson" label="法人姓名"></el-table-column>
            <el-table-column prop="idCard" label="法人身份证号"></el-table-column>
            <el-table-column label="法人身份证图片">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.idCardImage" height="30" style="display: flex;"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="licenseNumber" label="营业执照号"></el-table-column>
            <el-table-column label="营业执照图片">
                <template slot-scope="scope">
                    <div style="display: flex; align-items: center;">
                        <img :src="scope.row.licenseImage" height="30" style="display: flex;"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="mobile" label="手机号码"></el-table-column>
            <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="edit(scope.row.id)">编辑</el-button>
                    <el-popconfirm title="您确定要删除这条数据吗？" @confirm="del(scope.row.id)" class="l10">
                        <el-button size="mini" type="danger" slot="reference">删除</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <!--        @size-change= 每页多少条 -->
        <!--        @current-change 当前多少页-->
        <el-pagination @size-change="sizeReload" @current-change="pageReload" :current-page="page"
                       :page-sizes="[20, 100, 200, 300, 400]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>
<script>
    export default {
        name: 'index',
        data() {
            return {
                list: [],
                isLoad: false,
                pageSize: 20,
                total: 0,
                page: 1,
                number: 0,
                // 查询
                item: {}
            }
        },
        created() {
            this.loadList()
        },
        methods: {
            loadList() {
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.post('/admin/business/list', {
                    page: this.page,
                    limit: this.pageSize,
                    businessName: this.item.businessName,
                    mobile: this.item.mobile,
                    licenseNumber: this.item.licenseNumber
                })
                    .then(res => {
                        console.log(res);
                        this.isLoad = !this.isLoad
                        this.list = res.data.records
                        this.total = res.data.total
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            add() {
                this.$router.push({path: '/Merchant/edit.html'});
            },
            edit(id) {
                this.$router.push({
                    path: '/Merchant/edit.html',
                    query: {
                        id: id
                    }
                });
            },
            //
            del(id) {
                if (this.isLoad) {
                    return
                }
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/business/delete', {
                    data: [
                        id
                    ]
                })
                    .then(() => {
                        this.isLoad = !this.isLoad
                        this.$message.success({
                            message: '删除成功',
                            showClose: false
                        });
                        this.loadList()
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            delAll() {
                let id = []
                for (let key in this.multipleSelection) {
                    let item = this.multipleSelection[key]
                    id.push(item.id)
                }
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.delete('/admin/business/delete', {
                    data: id
                }).then(() => {
                    this.isLoad = !this.isLoad
                    this.$message.success({
                        message: '删除成功',
                        showClose: false
                    });
                    this.loadList()
                })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            },
            sizeReload(val) {
                this.pageSize = val
                this.loadList()
            },
            pageReload(val) {
                this.page = val
                this.loadList()
            },
            // 搜索查询
            submit() {
                this.item.page = 1
                this.loadList()
            },
            // 导出
            excelOut() {
                return;
                if (this.isLoad)
                    return
                this.isLoad = !this.isLoad
                this.axios.get('/Member/excelOut', {
                    params: {
                        nickname: this.item.nickname,
                        title: this.item.title
                    }
                })
                    .then(res => {
                        this.isLoad = !this.isLoad
                        // 导出
                        window.open(res.url)
                    })
                    .catch(() => {
                        this.isLoad = !this.isLoad
                    })
            }
        }
    }
</script>
<style scoped>
</style>